import React from 'react';
import {Link} from 'gatsby';

const LogoIcon = () => (
  <Link to= "/"><img src={require("./Kratos_main_white.png")} alt="Main Kratos Logo"></img></Link>
);

export default LogoIcon;
